export default "__VITE_ASSET__BYk7bHH___"